import React, { useContext } from 'react'
import GraphTable from '../mechanisms/graphtable'
import DashView from '../mechanisms/dashview'
import { DashboardContext } from '../mechanisms/card'
import { formatCurrency } from '../functions'
import { currencyPrefix } from '../single-card'

const formatConversion = (value) => `${Number(value || 0).toFixed(2)} %`

const ConversionRateDashboard = ({ data = [] }) => {

    const { type } = useContext(DashboardContext)
    // A taxa considera uma corte de oportunidades que já passaram por QUALIFIED.
    // Oportunidade conquistada sem histórico anterior de qualificação não entra no cálculo;
    // 0% aparece apenas quando existe pelo menos uma qualificada que ainda não converteu.
    const rows = data.filter(row => Number(row?.qualified || 0) > 0)

    return (
        <>
            {type === 'table' ? <GraphTable rows={rows} columns={[
                { field: 'journey_name', headerName: 'Jornada', flex: 1 },
                { field: 'conquered', headerName: 'Conquistadas', flex: 1 },
                { field: 'qualified', headerName: 'Qualificadas', flex: 1 },
                {
                    field: 'value', headerName: 'Valor conquistado', flex: 1,
                    renderCell: ({ value, row }) => `${currencyPrefix[row?.currency]} ${formatCurrency(value*100, row?.currency)}`
                },
                {
                    field: 'conversion', headerName: 'Taxa de conversão', flex: 1,
                    renderCell: ({ value }) => formatConversion(value)
                }
            ]} />
                : <DashView name='conversionratejourneyopportunities' rows={rows} vx='journey_name' vy={['conversion', 'count', 'value']} renderValue={(vy, row) => {
                    if (vy === 'conversion')
                        return formatConversion(row[vy])
                    if (vy === 'value')
                        return `${currencyPrefix[row?.currency]} ${formatCurrency(row[vy]*100, row?.currency)}`
                    return row[vy]
                }} />
            }
        </>
    )
}

export default ConversionRateDashboard
